import { parameters } from '../../constants/parameters';
import * as genericApi from './generic-api';
import { NewspostStats } from '../../entities/newspost-stats';

export const getStatsPerUserCategory = async (token: string, params?: object): Promise<NewspostStats> => {
  const url = `${parameters.api.baseUrl}/newsposts/stats`;

  return genericApi.one<NewspostStats>(token, url, params);
};

export const exportStatsPerUserCategory = async (token: string, params?: object): Promise<Blob> => {
  const url = `${parameters.api.baseUrl}/newsposts/stats/export`;

  return genericApi.blob(token, url, params);
};
